import { createContext, useEffect, useState } from 'react';

import useLocalStorage from './local-storage-controller';

export enum StageDisplayType {
  FullScreen = 'fullScreen',
  Normal = 'normal',
}

export const StageDisplayContext = createContext({
  stageDisplayType: '',
  setStageDisplayType: (_: StageDisplayType) => {},
});
StageDisplayContext.displayName = 'StageDisplayContext';

const useStageDisplayController = () => {
  const [stageDisplayType, setStageDisplayType] = useState<StageDisplayType>(
    StageDisplayType.Normal
  );

  const [localStorageStageDisplayType, setLocalStorageStageDisplayType] = useLocalStorage(
    'tome-stage-display-type',
    ''
  );

  useEffect(() => {
    if (localStorageStageDisplayType === StageDisplayType.FullScreen) {
      setLocalStorageStageDisplayType(StageDisplayType.FullScreen);
      setStageDisplayType(StageDisplayType.FullScreen);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    stageDisplayType,
    setStageDisplayType: (type: StageDisplayType) => {
      setLocalStorageStageDisplayType(type);
      setStageDisplayType(type);
    },
  };
};

export default useStageDisplayController;
